import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'field-template',
  templateUrl: './template.component.html'
})
export class TemplateComponent extends FieldType {}
